import { useRef, useEffect, useState } from 'react';
import { useDrop } from 'react-dnd';
import useSetHoverMarkerStyle from '../../../hooks/useSetHoverMarkerStyle';
import useSetIsSameTimeForViewType from '../../../hooks/useSetIsSameTimeForViewType';
import { styled } from '../../../lib/styles';
import { extractMonitorPayload } from '../lib';
import { jsx as _jsx } from "react/jsx-runtime";
export const DropTargetElement = styled.div.withConfig({
  displayName: "DropComponent__DropTargetElement",
  componentId: "sc-1j7tqoa-0"
})(["display:", ";width:100%;height:100%;position:absolute;z-index:4;"], ({
  isDragging
}) => isDragging ? 'block' : 'none');
export const DropComponent = ({
  droppedMoment,
  dragGroup,
  onDndDrop,
  onDndHover,
  canDrop,
  render,
  viewType
}) => {
  const containerRef = useRef(null);
  const hookParams = {
    containerRef,
    viewType
  };
  const [hoverMarkerStyle, setHoverMarkerStyle] = useSetHoverMarkerStyle(hookParams);
  const [isSameTime, setIsSameTime] = useSetIsSameTimeForViewType(hookParams);
  const dropTargetPayload = {
    containerRef,
    droppedMoment
  };
  const [{
    itemBeingDragged,
    canDropResult,
    isOver
  }, connectDropTarget] = useDrop({
    accept: dragGroup,
    drop(item, monitor) {
      onDndDrop(Object.assign({}, dropTargetPayload, extractMonitorPayload(monitor)));
    },
    hover(item, monitor) {
      onDndHover(Object.assign({}, dropTargetPayload, extractMonitorPayload(monitor)));
      setHoverMarkerStyle(dropTargetPayload, monitor);
      setIsSameTime(dropTargetPayload, monitor);
    },
    canDrop(item, monitor) {
      return canDrop(Object.assign({}, dropTargetPayload, extractMonitorPayload(monitor)));
    },
    collect(monitor) {
      return {
        // This is an arbitrary object set by the drag source
        itemBeingDragged: monitor.getItem(),
        canDropResult: monitor.canDrop(),
        isOver: monitor.isOver()
      };
    }
  });
  const [isDragging, setIsDragging] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setIsDragging(Boolean(itemBeingDragged));
    }, 0);
  }, [itemBeingDragged]);
  return render({
    canDropResult,
    isOver,
    isDragging,
    hoverMarkerStyle,
    isSameTime,
    containerRef,
    dropTarget: /*#__PURE__*/_jsx(DropTargetElement, {
      "data-test-id": `drop-target-element-${droppedMoment.format('D-M-YYYY')}`,
      isDragging: isDragging,
      ref: connectDropTarget
    }, "drop-target")
  });
};